<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 263.09 496.18"
    class="c-icon"
  >
    <line
      x1="15"
      y1="15"
      x2="248.09"
      y2="248.09"
      class="c-icon__line c-icon__line--thick"
    />
    <line
      x1="15"
      y1="481.18"
      x2="248.09"
      y2="248.09"
      class="c-icon__line c-icon__line--thick"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconRight',
};
</script>